import React from 'react';
import Header from '../Components/Header';

const SpotTrading = () => {
  return <Header>Spot Trading</Header>;
};

export default SpotTrading;
